type TypePlanStatePoiStatus = {|
  +spaceId: string,
  +poiType: "room" | "desk",
  +status: "available" | "busy" | "noInformation" | "mixed",
  +color: string,
  +floorId: string
|}

export type { TypePlanStatePoiStatus }

type TypePlanActionPoiStatusSet = {|
  +type: "PLAN_POI_SET",
  +payload: TypePlanStatePoiStatus[]
|}

export type { TypePlanActionPoiStatusSet }

type RestaurantAttendance = {|
  +time: number,
  +color: string
|}

export type { RestaurantAttendance }

type RestaurantAttendanceSet = {|
  +type: "RESTAURANT_ATTENDANCE_SET",
  +payload: RestaurantAttendance
|}

export type { RestaurantAttendanceSet }

//TODO: Pas de Exact à cause de https://github.com/facebook/flow/issues/2405
type TypePlanState = {|
  +status: TypePlanStatePoiStatus[],
  +restaurantAttendance: RestaurantAttendance
|}

const initialState: TypePlanState = {
  status: []
}

const reducerPoiStatusSet = (
  state: TypePlanState,
  action: TypePlanActionPoiStatusSet
): TypePlanState => ({
  ...state,
  status: action.payload
})

const reducerRestaurantAttendanceSet = (
  state: TypePlanState,
  action: RestaurantAttendanceSet
): TypePlanState => ({
  ...state,
  restaurantAttendance: action.payload
})

const reducer = (
  state: TypePlanState = initialState,
  action: TypePlanActionPoiStatusSet
): TypePlanState => {
  if (action.type === "PLAN_POI_SET") {
    return reducerPoiStatusSet(state, action)
  }
  if (action.type === "RESTAURANT_ATTENDANCE_SET") {
    return reducerRestaurantAttendanceSet(state, action)
  }

  return state
}

export default reducer
export type { TypePlanStatePoiStatus as TypeStatus }



// WEBPACK FOOTER //
// ./src/store/plans/PlansReducer.js